function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) {
  if (!REACT_ELEMENT_TYPE) {
    REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  }

  var defaultProps = type && type.defaultProps;
  var childrenLength = arguments.length - 3;

  if (!props && childrenLength !== 0) {
    props = {
      children: void 0
    };
  }

  if (props && defaultProps) {
    for (var propName in defaultProps) {
      if (props[propName] === void 0) {
        props[propName] = defaultProps[propName];
      }
    }
  } else if (!props) {
    props = defaultProps || {};
  }

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = new Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 3];
    }

    props.children = childArray;
  }

  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: type,
    key: key === undefined ? null : '' + key,
    ref: null,
    props: props,
    _owner: null
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import noop from '../shared/noop';

var Dialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dialog, _React$Component);

  function Dialog(props) {
    var _this;

    _classCallCheck(this, Dialog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dialog).call(this, props));
    _this.state = {
      bodyOverflow: ''
    };
    return _this;
  }

  _createClass(Dialog, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen === this.props.isOpen || !nextProps.lockScroll) return;

      if (nextProps.isOpen) {
        this.setState({
          bodyOverflow: document.body.style.overflow
        });
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = this.state.bodyOverflow;
        this.setState({
          bodyOverflow: ''
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cancelButton = _this$props.cancelButton,
          children = _this$props.children,
          className = _this$props.className,
          closeButton = _this$props.closeButton,
          hasMask = _this$props.hasMask,
          isOpen = _this$props.isOpen,
          onClose = _this$props.onClose,
          onSubmit = _this$props.onSubmit,
          outsideClose = _this$props.outsideClose,
          submitButton = _this$props.submitButton,
          title = _this$props.title;
      return isOpen && ReactDOM.createPortal(_jsx("div", {
        className: "dialog-wrapper"
      }, void 0, _jsx("div", {
        className: className ? "lrc-dialog ".concat(className) : 'lrc-dialog'
      }, void 0, (title || closeButton) && _jsx("div", {
        className: "dialog-head"
      }, void 0, title && _jsx("h2", {
        className: "dialog-title"
      }, void 0, title), closeButton && _jsx("button", {
        className: "dialog-close",
        onClick: onClose
      }, void 0, closeButton)), _jsx("div", {
        className: "dialog-body"
      }, void 0, children), (cancelButton !== '' || submitButton !== '') && _jsx("div", {
        className: "dialog-foot"
      }, void 0, cancelButton && _jsx("button", {
        className: "dialog-cancel",
        onClick: onClose
      }, void 0, cancelButton), submitButton && _jsx("button", {
        className: "dialog-submit",
        onClick: onSubmit
      }, void 0, submitButton))), hasMask && _jsx("div", {
        className: "dialog-mask",
        onClick: outsideClose ? onClose : null,
        "aria-hidden": true
      })), document.body);
    }
  }]);

  return Dialog;
}(React.Component);

_defineProperty(Dialog, "defaultProps", {
  cancelButton: '',
  className: '',
  closeButton: '',
  hasMask: true,
  lockScroll: true,
  isOpen: false,
  onClose: noop,
  onSubmit: noop,
  outsideClose: false,
  submitButton: '',
  title: ''
});

export default Dialog;